import React from 'react';
import { useHistory } from 'react-router-dom';
import { Alert, Button } from '..';
import routeConfiguration from '../../routeConfiguration';
import { createResourceLocatorString } from '../../util/routes';
import css from './Alert.css';
import { CREDITS_PACKAGE_1 } from '../../credits-config';
import { SEARCH_PARAM_PACKAGE_KEY } from '../../containers/BalancePage/configs';

const AlertNotEnoughCredits = () => {
    const history = useHistory();

    return (
        <Alert
            showAsPlainText
            header="Keine Credits verfügbar"
            description="Füge neue Credits hinzu, um Zusatzpakete aktivieren zu können."
            rootClassName={css.alert}
            closeAllowed
            closeClassName={css.closeButton}
        >
            <Button
                type="button"
                onClick={() =>
                    history.push(
                        createResourceLocatorString(
                            'BalancePage',
                            routeConfiguration(),
                            {},
                            { [SEARCH_PARAM_PACKAGE_KEY]: CREDITS_PACKAGE_1 }
                        )
                    )
                }
            >
                Hinzufügen
            </Button>
        </Alert>
    );
};

export default AlertNotEnoughCredits;
